const isBrowser = typeof window !== 'undefined';
const defaultOrigin = isBrowser && window.location.origin ? window.location.origin : 'https://squash.encrypted.synology.me';
const defaultWsOrigin = isBrowser && window.location.host
  ? (window.location.protocol === 'https:' ? 'wss://' : 'ws://') + window.location.host + '/ws'
  : 'wss://squash.encrypted.synology.me/ws';

const config = {
  development: {
    apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:8004',
    wsUrl: process.env.REACT_APP_WS_URL || 'ws://localhost:8005',
    useTimers: false
  },
  production: {
    // Gebruik het geldige hoofddomein / dynamische origin i.p.v. api.encrypted.synology.me (certificaatfout)
    apiUrl: process.env.REACT_APP_API_URL || defaultOrigin,
    wsUrl: process.env.REACT_APP_WS_URL || defaultWsOrigin,
    useTimers: false
  }
};

// Determine environment
const env = process.env.NODE_ENV || 'development';
const currentConfig = config[env];

// Add debugging info
console.log('[Config] Environment:', env);
console.log('[Config] API URL:', currentConfig.apiUrl);
console.log('[Config] WebSocket URL:', currentConfig.wsUrl);

export default currentConfig; 